import { ElementType } from 'react'

import { Breadcrumb, BreadcrumbType, CategorySub } from '@karakuri-web/faq-type'

import { Breadcrumbs } from './Breadcrumbs'
import { BreadcrumbsList } from './BreadcrumbsList'
import { Tag, TagCloud } from './TagCloud'

export function BreadcrumbsNavigation({
  breadcrumbType,
  breadcrumb,
  relatedCategories = [],
  topTitle,
  tags = [],
  LinkComponent,
  onLinkClick,
}: {
  breadcrumbType?: BreadcrumbType | null
  breadcrumb?: Breadcrumb
  relatedCategories?: CategorySub[]
  topTitle: string
  tags?: Tag[]
  LinkComponent?: ElementType
  onLinkClick?: (link: string, option: any) => void
}) {
  switch (breadcrumbType) {
    case 'tag':
      return <TagCloud tags={tags} LinkComponent={LinkComponent} onLinkClick={onLinkClick} />
    case 'breadcrumbAll':
      return breadcrumb ? (
        <BreadcrumbsList
          {...breadcrumb}
          relatedCategories={relatedCategories}
          topTitle={topTitle}
          LinkComponent={LinkComponent}
          onLinkClick={onLinkClick}
        />
      ) : null

    case 'breadcrumb':
      return breadcrumb ? (
        <Breadcrumbs
          {...breadcrumb}
          topTitle={topTitle}
          LinkComponent={LinkComponent}
          onLinkClick={onLinkClick}
        />
      ) : null

    default:
      return null
  }
}
